import Vue from 'vue'
import App from './App.vue'
import router from "./routes"
import store from "./store";
import "./assets/style/./reset.css";
// import "./assets/style/global.css";
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import VueParticles from 'vue-particles'  //粒子特效
Vue.use(VueParticles)
Vue.use(ElementUI);
// Vue.config.productionTip = false
new Vue({
    render: h => h(App),
    router,
    store
}).$mount('#app')